<template>
    <div>
        <router-view/>
        <SvgMarkings></SvgMarkings>
        <loader></loader>
        <WhatsNewModal v-if="showWhatsNew"></WhatsNewModal>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import SvgMarkings from '@mobile/components/global/SvgMarkings';
import Loader from './common/Loader';
import WhatsNewModal from './common/WhatsNewModal';
import EventBus from '../eventBus';
import '@css/style.scss';
import '@sass/manager.scss';

export default {
    name: 'DesktopApp',
    components: {SvgMarkings, Loader, WhatsNewModal},
    data() {
        return {
            hasUser: false,
        }
    },

    computed: {
        showWhatsNew: function () {
            const unauthRoutes = ['Login', 'register', 'ForgotPassword'];
            return this.hasUser && !unauthRoutes.includes(this.$route.name);
        }
    },

    created: function () {
        this.$router.beforeEach((to, from, next) => {
            this.loadProject(to.params).finally(() => next());
        });

        this.$http.interceptors.response.use(undefined, function (err) {
            return new Promise(() => {
                if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                    this.$store.dispatch(logout);
                }
                throw err;
            });
        });
    },

    mounted: function () {
        EventBus.$on('user-loaded', () => {
            this.hasUser = true;
        });
        this.loadUser();
        this.loadProject(this.$route.params);
        this.showServerFlash();
    },

    methods: {
        // Message handed over by the server after a password set/reset (layouts/manager.blade.php).
        showServerFlash: function () {
            const flash = window.__dotagFlash;

            if (!flash || !flash.message) {
                return;
            }

            window.__dotagFlash = null;

            this.$nextTick(() => {
                this.$bvToast.toast(flash.message, {
                    title: 'Password',
                    variant: flash.variant || 'success',
                    solid: true,
                    autoHideDelay: 6000
                });
            });
        },

        logout: function () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push('/login')
                });
        },

        loadUser: function () {
            if (typeof this.$store.state.user.id === 'undefined') {
                this.$store.dispatch('loadLoggedInUser').then((user) => {
                    this.$store.state.user = user;
                    EventBus.$emit('user-loaded', user);
                });
            } else {
                EventBus.$emit('user-loaded', this.$store.state.user);
            }
        },

        loadProject: function (params) {
            return new Promise((resolve) => {
                if (params && params.id && this.$store.state.company.id && !this.$store.state.project.id) {
                    this.$store.dispatch('loadProject', params.id).finally(() => resolve());
                } else {
                    resolve();
                }
            });
        }
    }
}
</script>
